module.exports = __webpack_public_path__ + "img/microscope.3d338b4a.svg";